<template>
    <div class="pack-selection-widget" id="packDetailPage">
        <div class="vue-item-list" :class="{ 'disabled-selection': overrideReasonDetail}">
            <PackItem
                v-for="(packItem, index) in packData.items"
                :key="index"
                :products-list="packItem.products ? packItem.products : []"
                :product-info="packItem.productInfo"
                :field-keys="packData.fieldKeys"
                :option-types="packItem.optionTypes"
                :component-order="packItem.productComponentDefault"
                :index="index"
                :out-of-stock="packItemHasNoStock || hasNoOptionsInStock(packItem.products) || hasAllVariantsOverride(packItem.products)"
                :pack-item-has-all-variants-override="hasAllVariantsOverride(packItem.products)"
                :status-override="statusOverride"
                :override-reason-detail="overrideReasonDetail"
            />
        </div>
    </div>
</template>

<script>
// import ListItemBtn from "@/components/ProductPage/Mobile-BlackRabbit/partials/buttonTypes/ListItemBtn";
import PackItem from './PackItem';
import FloatBtn from '../../buttonTypes/FloatBtn';

import {storePdp} from '@/store/product-page';
import {isEmpty} from 'lodash-es';

export default {
    storePdp,
    name: 'Packs',
    components: {
        PackItem,
        FloatBtn,
    },
    props: {
        lockButton: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            selectionIsOpen: false,
            statusOverride: 'TI',
            overrideReasonDetail: '',
            packItemHasNoStock: false
        };
    },
    computed: {
        kStrings() {
            return storePdp.getters.kStrings;
        },
        currency() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/currency'];
        },
        packData() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/packData'];
        },
        showOptionsPopup() { // '' or null (hides), primary, secondary or qty (shows)
            return storePdp.getters['pdpDesktop/addToCartDesktop/showOptionsPopup'];
        },
        canAddToCart() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/canAddToCart'];
        },
        selectedPackProducts() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedPackProducts'];
        },
        numberOfPackItems() {
            return this.packData.items.length;
        },
        readyPackItems() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/readyPackItems'];
        },
        numberOfReadyPackItems() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/numberOfReadyPackItems'];
        },
        /*outOfStockPack() {
            return !storePdp.getters.hasStock;
        },*/
    },
    watch: {},
    created() {},
    mounted() {
        this.$nextTick(() =>{
            //setTimeout(() => this.scrollToFirstUnselected(), 500);
            //this.selectedPackProducts = new Array(this.packData.items.length).fill(null);
        });
    },
    methods: {
        handleWarnings() {
            let warning = this.numberOfReadyPackItems != this.numberOfPackItems;
            //console.log('pkn warning: ', warning); 
          /*  if(warning) {
                setTimeout(() => this.scrollToFirstUnselected(), 250);
            }*/
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateGlobalCartWarningEvent', warning);
        },
        hasNoOptionsInStock(options) {
            let filteredOptionsList = options.filter(product => product.stock > 0);
            let noItemsInStock = filteredOptionsList.length == 0;
            if(noItemsInStock) { // todo review out of stock pack items conditions
                this.packItemHasNoStock = true;
            }
            
            return noItemsInStock;
        },
        
        // has variants to choose, but no options enabled from stock or override status
        hasAllVariantsOverride(options) {
            // override status filter
            let hasAllVariantsOverride = false;
            let filteredStatusList = options.filter(product => !product.overrideStatus);
            let foundOverride = options.find(product => product.overrideStatus);
            if (filteredStatusList.length == 0) {
                hasAllVariantsOverride = true;
                if(foundOverride) {
                    this.statusOverride = foundOverride.overrideStatus.newStatus ? foundOverride.overrideStatus.newStatus : 'TI';
                    this.overrideReasonDetail = foundOverride.overrideStatus.reasonDetail ? foundOverride.overrideStatus.reasonDetail : this.kStrings.kTEMPORARILY_UNAVAILABLE;
                }
            }
            return hasAllVariantsOverride;
        },
        
        /*scrollToFirstUnselected() {
            let pknPage = document.getElementById('packDetailsPage');
            let warningElems = pknPage.getElementsByClassName('scroll-on-btn');
            if (warningElems && warningElems.length > 0) {
                let fistItem = warningElems.item(0);
                if (fistItem) {
                    fistItem.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center',
                    });
                }
            }
        },*/
    },
};
</script>

<style lang="scss">
@import "../../../styles/packSelectionWidget";
</style>
